import { render, staticRenderFns } from "./AAAhuRuntime.vue?vue&type=template&id=5973c656&"
import script from "./AAAhuRuntime.vue?vue&type=script&lang=js&"
export * from "./AAAhuRuntime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports